// src/services/patientBooking.js
//
// Hold, booking and checkout calls (Patient Appointments Task 2).
//
// The raw hold token is passed in and out of these functions only. It is never
// written to localStorage/sessionStorage, the URL, logs or analytics. Payment
// redirects are chosen by the server, so no URL is sent.

import { api } from "../lib/patientApi";

const BASE = "/api/v1/patients/me/appointments";

export const patientBookingApi = {
  async createHold({ slotInventoryId, serviceVersionId, consultationMode, practiceLocationId, displayTimezone, replaceExisting = false }) {
    const res = await api.post(`${BASE}/holds`, {
      slot_inventory_id: slotInventoryId,
      service_version_id: serviceVersionId,
      consultation_mode: consultationMode,
      practice_location_id: practiceLocationId || null,
      display_timezone: displayTimezone || null,
      replace_existing: replaceExisting,
    });
    return res.data;
  },

  async currentHold() {
    const res = await api.get(`${BASE}/holds/current`);
    return res.data;
  },

  async recoverHold(holdId, { serviceVersionId, displayTimezone } = {}) {
    const res = await api.post(`${BASE}/holds/${holdId}/recover`, {
      service_version_id: serviceVersionId || null,
      display_timezone: displayTimezone || null,
    });
    return res.data;
  },

  async releaseHold(holdId, holdToken) {
    const res = await api.post(`${BASE}/holds/${holdId}/release`, { hold_token: holdToken });
    return res.data;
  },

  async book({ holdId, holdToken, slotInventoryId, serviceVersionId, patientBookingNote, bookedForPatientName }) {
    const res = await api.post(BASE, {
      hold_id: holdId,
      hold_token: holdToken,
      slot_inventory_id: slotInventoryId,
      service_version_id: serviceVersionId,
      patient_booking_note: patientBookingNote || undefined,
      booked_for_patient_name: bookedForPatientName || undefined,
    });
    return res.data;
  },

  async startCheckout(appointmentId) {
    const res = await api.post(`${BASE}/${appointmentId}/payments/stripe/checkout`);
    return res.data;
  },
};

export default patientBookingApi;
